import expect from '@src/slide/infrastructure/module/independent/assert/expect';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { NOTE_DEFAULT_HEIGHT } from '@editor/src/js/constants';

/**
 * 根据传入的height值，去掉对应的note-area高度，返回剩余的高度
 */
export const getHeightFixedByNoteHeight = (height, noteAreaHeight) => {
    if (browser.isMobile) {
        return height;
    }
    if (!expect(noteAreaHeight).isNullOrUndefined()) {
        return height - noteAreaHeight;
    }
    return height - NOTE_DEFAULT_HEIGHT;
};
